"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DATE_FORMATS = void 0;
var DATE_FORMATS;
(function (DATE_FORMATS) {
    DATE_FORMATS["MM_DD_YYYY"] = "MM/DD/YYYY";
    DATE_FORMATS["MM_DD_YYYY_hh_mm_A"] = "MM/DD/YYYY hh:mm A";
    DATE_FORMATS["MM_DD_YYYY_hh_mm_ss_A"] = "MM/DD/YYYY hh:mm:ss a";
    DATE_FORMATS["YYYY_MM_DDThh_mm_ss"] = "YYYY-MM-DDTHH:mm:ss[Z]";
    DATE_FORMATS["MMM_DO"] = "MMM Do";
})(DATE_FORMATS || (exports.DATE_FORMATS = DATE_FORMATS = {}));
